import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { gsap } from 'gsap';
import { md, lg, xl, wide, xwide } from '../common';

export function initKnowledgeBase(parent) {
  if (!parent) return;

  const swiperEl = document.querySelector(
    '.knowledge-base__swiper, .knowledge-base2__swiper',
  );

  new Swiper(swiperEl, {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      [md]: { slidesPerView: 2, spaceBetween: 20 },
      [lg]: { slidesPerView: 3, pagination: false, spaceBetween: 20 },
      [wide]: { slidesPerView: 3, pagination: false, spaceBetween: 24 },
      [xwide]: { slidesPerView: 3, pagination: false, spaceBetween: 32 },
    },
  });

  const cards = parent.querySelectorAll(
    '.knowledge-base__item, .knowledge-base2__item',
  );
  cards.forEach((card, index) => {
    gsap.set(card, {
      opacity: 0,
      scale: 0.8,
      transformOrigin: 'center center',
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: 'top 75%',
        toggleActions: 'play none none none',
      },
    });

    tl.to(card, {
      opacity: 1,
      scale: 1.02,
      duration: 0.5,
      ease: 'power1.out',
      delay: index * 0.1,
    }).to(card, {
      scale: 1,
      duration: 0.3,
      ease: 'power1.inOut',
    });
  });
}

export function initKnowledgeBases() {
  const blocks = document.querySelectorAll('.knowledge-base, .knowledge-base2');
  blocks.forEach((block) => initKnowledgeBase(block));
}
